import { render, staticRenderFns } from "./NewLead.vue?vue&type=template&id=52368963&scoped=true&lang=pug"
import script from "./NewLead.vue?vue&type=script&lang=js"
export * from "./NewLead.vue?vue&type=script&lang=js"
import style0 from "./NewLead.vue?vue&type=style&index=0&id=52368963&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52368963",
  null
  
)

export default component.exports